import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { InfiniteScroll, PageList } from "../components"
import { PageLayout } from "../components/layout"
import { Button, Card, Icon, IconButton, StatePanel, Tag } from "../components/ui"
import { LinkHelper, ShareHelper } from "../helpers"
import { getApiUrl } from '../core/config/api'
import "./pages-collection.scss"

// Fontaine M63A — one collection card. Same behaviour as the legacy
// PageListItem2 this page used: title and Read More both navigate to
// page.url, Share sends the datasheet media link when there is one,
// otherwise the current path. The card body itself is not clickable
// (the legacy card's onClick was defined but never attached).
const PageCard = ({ page }) => {
    const location = useLocation()

    const imageUrl = getApiUrl(`/media/${page?.image_other || page?.image}`)

    const onShareClick = (e) => {
        e.preventDefault()

        const link = page?.datasheet
            ? LinkHelper.link(getApiUrl(`/media/${page?.datasheet}`))
            : LinkHelper.link(location.pathname)
        ShareHelper.share(link)
    }

    return (
        <Card as="article" padding="none" className="pages-collection__card">
            <img className="pages-collection__image" src={imageUrl} alt="" />

            <div className="pages-collection__body">
                { page?.tags?.length > 0 && (
                    <div className="pages-collection__tags">
                        { page.tags.map(t => (
                            <Tag key={t?.name?.en} size="sm">{t?.name?.en}</Tag>
                        ))}
                    </div>
                )}

                <h3 className="pages-collection__title">
                    <Link to={page?.url}>{ page?.title }</Link>
                </h3>

                <p className="pages-collection__desc">{ page?.description }</p>

                <div className="pages-collection__actions">
                    <Button variant="secondary" to={page?.url}>Read More</Button>

                    <IconButton variant="ghost" label="Share" onClick={onShareClick}>
                        <Icon name="Share2" size="sm" />
                    </IconButton>
                </div>
            </div>
        </Card>
    )
}

// Fontaine M63A — the News/Events collection shell. Fetch contract is the
// one the legacy PageList sent: POST /api/pages/search with the route's
// type, created_at desc, 3-item pages.
const PagesCollection = ({ type }) => {
    // TODO autoplay
    return (
        <PageLayout className={`pages-collection pages-collection--${type} flex-grow-1`}>
            { type === 'event' && (
                <div className="pages-collection__video">
                    <video playsInline loop muted width="100%">
                        <source src={`/assets/experience.mov`} />
                    </video>
                </div>
            )}

            <InfiniteScroll
                fetchUrl='/api/pages/search'
                fetchParams={{
                    type,
                    sort: { field: 'created_at', direction: 'desc' }
                }}
                fetchLimit={3}
            >
                {({ items, isLoading }) => (
                    <div className="pages-collection__grid">
                        {items.length > 0 && items.map((page) => (
                            <PageCard key={page.id} page={page} />
                        ))}

                        { !isLoading && items.length === 0 && (
                            <StatePanel
                                className="pages-collection__empty"
                                state="empty"
                                title="No pages found."
                                description={null}
                            />
                        )}
                    </div>
                )}
            </InfiniteScroll>
        </PageLayout>
    )
}

const Pages = ({ type }) => {
    if (type === 'news' || type === 'event') {
        return <PagesCollection type={type} />
    }

    // Legacy shell — still serves /master-library (type "library"), which is
    // outside the M63A News/Events slice. Markup unchanged.
    return (
        <main id="pages" className={`flex-grow-1 mb-5 ${type}`}>
            <div className="container">
                <div id="page" className="mt-lg-3">
                    <PageList
                        type={type}
                        itemComponent={2}
                    />
                </div>
            </div>
        </main>
    )
}

export default Pages
